import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import logoImg from "@/assets/logo.png";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "About", href: "/about" },
  { label: "Services", href: "/services" },
  { label: "Pricing", href: "/pricing" },
  { label: "Gallery", href: "/gallery" },
  { label: "Testimonials", href: "/testimonials" },
  { label: "Contact", href: "/contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-slate-900/95 backdrop-blur-xl shadow-elevated border-b border-primary/10"
          : "bg-slate-900/80 backdrop-blur-md"
      }`}
    >
      <div className="container mx-auto flex items-center justify-between h-20 px-4">
        <Link to="/" className="flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <img src={logoImg} alt="Precision Mobile Auto" className="h-10 w-10 sm:h-12 sm:w-12 object-contain" />
          <div className="flex flex-col">
            <span className="font-heading text-sm sm:text-base uppercase tracking-wider text-secondary-foreground leading-tight">
              Precision
            </span>
            <span className="font-heading text-[10px] sm:text-xs uppercase tracking-[0.2em] text-primary leading-tight">
              Mobile Auto
            </span>
          </div>
        </Link>

        {/* Desktop */}
        <div className="hidden lg:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`relative px-3 xl:px-4 py-2 font-heading text-[11px] uppercase tracking-widest transition-all duration-300 rounded-md ${
                location.pathname === link.href
                  ? "text-primary"
                  : "text-secondary-foreground/70 hover:text-primary hover:bg-primary/5"
              }`}
            >
              {link.label}
              {location.pathname === link.href && (
                <span className="absolute bottom-0.5 left-3 right-3 h-[2px] bg-gradient-to-r from-primary to-orange-glow rounded-full" />
              )}
            </Link>
          ))}
        </div>

        {/* Mobile toggle */}
        <button
          onClick={() => setOpen(!open)}
          className="lg:hidden text-secondary-foreground p-2 rounded-lg hover:bg-primary/10 transition-colors"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-slate-900/98 backdrop-blur-xl border-t border-primary/10 animate-fade-in max-h-[calc(100svh-5rem)] overflow-y-auto">
          <div className="p-3 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setOpen(false)}
                className={`block px-4 py-3 rounded-lg font-heading text-sm uppercase tracking-widest transition-all duration-300 ${
                  location.pathname === link.href
                    ? "text-primary bg-primary/10 border-l-2 border-primary"
                    : "text-secondary-foreground/70 hover:text-primary hover:bg-primary/5"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
